import { useParams, useRouteMatch } from 'react-router';
import { CampaignCreatorType, CampaignsPaths } from '@/services/dictionaries/Paths';

export const useCampaignScreensPathsChecker = () => {
    const { type } = useParams<{ name: string; type: string }>();
    const isAbCampaign = type === CampaignCreatorType.AB;
    const isDetailsScreen = useRouteMatch(CampaignsPaths.CampaignCreatorDetails)?.isExact;

    return { isDetailsScreen, isAbCampaign };
};
